import React from "react";

const MaleIcon = ({ fill, ...restProps }) => {
  return (
    <svg
      viewBox="0 0 27 27"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M12.5 2.739a.9.9 0 0 0-.384.341c-.079.116-.096.189-.096.42.001.239.017.304.11.44.06.088.175.205.257.26l.147.1 3.233.02L19 4.34l-3.132 3.132-3.132 3.132-.179-.137c-.465-.356-1.206-.725-1.891-.944-1.097-.349-2.419-.381-3.575-.086a6.53 6.53 0 0 0-4.24 3.456 6.2 6.2 0 0 0-.66 2.847c-.002.875.101 1.488.385 2.273a6.57 6.57 0 0 0 4.684 4.139c.777.178 1.828.215 2.52.089.625-.113 1.346-.345 1.831-.587a6.56 6.56 0 0 0 3.262-8.134A7 7 0 0 0 14 11.889l-.097-.132 3.128-3.128L20.16 5.5v2.703c0 2.992-.001 2.985.249 3.226a.824.824 0 0 0 1.182 0c.256-.247.249-.133.249-4.249s.007-4.002-.249-4.249c-.275-.266.012-.251-4.7-.249-3.571.001-4.291.01-4.391.057m-2.78 8.242c.978.213 1.731.625 2.443 1.337.973.971 1.439 2.083 1.441 3.442.002.81-.138 1.434-.48 2.14a4.84 4.84 0 0 1-2.495 2.378 4.9 4.9 0 0 1-4.082-.124c-1.309-.658-2.232-1.825-2.589-3.274-.12-.484-.147-1.368-.06-1.9.326-1.99 1.892-3.618 3.843-3.996l.419-.08c.211-.039 1.27.013 1.56.077"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
};

export default MaleIcon;
